import { fetchClient } from '@api/typedClient'
import {
  CrossroadsEntity,
  CrossroadsEntityType,
  ENTITY_GRID_ENDPOINT_MAP,
  GridPayload,
} from '@api/types'
import { useQuery } from '@tanstack/react-query'

export function useEntities(
  searchTerm: string,
  type: CrossroadsEntityType | CrossroadsEntityType[],
) {
  const types = Array.isArray(type) ? type : [type]

  return useQuery({
    queryKey: ['entities', types, searchTerm],
    queryFn: async () => {
      const results = await Promise.all(
        types.map(async (t) => {
          const endpoint = ENTITY_GRID_ENDPOINT_MAP[t]
          const { data, error } = await fetchClient.GET(
            // @ts-expect-error TODO: Dynamic entity endpoints not in OpenAPI spec
            endpoint,
            {
              params: {
                query: {
                  limit: 500,
                  search_term: searchTerm,
                },
              },
            },
          )

          if (error) {
            throw new Error(
              `Failed to fetch entities: ${JSON.stringify(error)}`,
            )
          }

          const response = data as unknown as GridPayload<CrossroadsEntity>
          return response.rows
        }),
      )
      return results.flat()
    },
  })
}
